export default {
  title: 'Estimator24 — Gayrimenkul Değerlendirme Servisi',
  description: 'Kesin fiyat analizi, yapay zeka ile değerlendirme ve piyasa dinamikleri tahmini',
  login: 'Hesabınıza giriş yapın'
}
